import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { CAROLINE_COILE_URL } from 'dpl/shared/constants/urls';

import CarolineCoile from 'dpl/assets/overview_pages/caroline-coile.jpeg';
import NateRitter from 'dpl/assets/overview_pages/nate-ritter.jpg';

const IMAGE_DIMS = { width: '243px', height: '292px' };

export default function AboutTheAuthorSection({ vetReviewed }) {
  return (
    <div className="AboutTheAuthorSection bg-sand row ph5 pv12 mt10">
      <div className="col-12 col-xl-8 mx-auto">
        <div className="flex flex-wrap flex-lg-nowrap mh8-md bb b--light-gray pb6 pb12-md">
          <div className="dn db-l">
            <SmartImage
              Tag="div"
              className="bg-center cover br4 mr12"
              src={CarolineCoile}
              loadingClass="bg-light-gray"
              {...IMAGE_DIMS}
            />
          </div>
          <div className="self-center">
            <h5 className="mb6 mb2-lg f4 f5-lg lh-normal">About the author</h5>
            <div className="aspect-ratio aspect-ratio--3x4 mb6 db dn-l">
              <div className="aspect-ratio--object">
                <SmartImage
                  Tag="div"
                  className="w-100 h-100 cover bg-center br4"
                  src={CarolineCoile}
                  loadingClass="bg-light-gray"
                />
              </div>
            </div>
            <p className="font-16-mobile">
              Canine specialist,{' '}
              <a
                href={CAROLINE_COILE_URL}
                className="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Caroline Coile, Ph.D.
              </a>
              , is the author of 34 dog books, including the top-selling
              Barron&apos;s Encyclopedia of Dog Breeds. She’s written thousands
              of magazine and web articles about dogs. She specializes in canine
              science, health, breeds and competitions. Caroline has won 20
              national dog-writing awards, and was a 2015 Inductee into the Dog
              Writers Association of America Hall of Fame.
            </p>
          </div>
        </div>
        {vetReviewed && (
          <div className="flex flex-wrap flex-lg-nowrap mh8-md pt6 pt12-md">
            <div className="self-center mr12-lg">
              <h5 className="mb6 mb2-lg f4 f5-lg lh-normal">
                Veterinarian reviewed
              </h5>
              <div className="aspect-ratio aspect-ratio--3x4 mb6 db dn-l">
                <div className="aspect-ratio--object">
                  <SmartImage
                    Tag="div"
                    className="w-100 h-100 cover bg-center br4"
                    src={NateRitter}
                    loadingClass="bg-light-gray"
                  />
                </div>
              </div>
              <p className="font-16-mobile">
                Dr. Nate Ritter, DVM is the Veterinary Medical Director at Good
                Dog. He earned his Bachelor of Science in Biology from Lafayette
                College and his Doctor of Veterinary Medicine degree from
                Virginia-Maryland College of Veterinary Medicine. He is a member
                of the American Veterinary Medical Association, New York State
                Veterinary Medical Society, the Veterinary Medical Association
                of New York City, and the Society for Theriogenology.
                Additionally, he is a USDA-accredited veterinarian.
              </p>
            </div>
            <div className="dn db-l">
              <SmartImage
                Tag="div"
                className="bg-center cover br4"
                src={NateRitter}
                loadingClass="bg-light-gray"
                crop
                {...IMAGE_DIMS}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

AboutTheAuthorSection.propTypes = {
  vetReviewed: PropTypes.bool.isRequired
};
